import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faPlus, faEye } from '@fortawesome/free-solid-svg-icons';
import ShoppingCartImage from '../../public/productcarting.jpg'; // Assume you have a shopping cart image

const AdminProductActions = () => {
  return (
    <div className="bg-white p-6 mt-20 ml-60 max-sm:ml-0 rounded-lg shadow-md max-sm:rounded-none max-sm:shadow-none flex max-sm:flex-col justify-between items-center">
      {/* Left Section - Add your products */}
      <div>
        <h2 className="text-2xl font-semibold text-gray-800">Add your products</h2>
        <p className="text-gray-500">Start by stocking your store with products your customers will love</p>

        <div className="mt-4 flex max-sm:mt-10 max-sm:flex-col space-x-4 max-sm:space-x-0">
          {/* Add Product Button */}
          <Link to="/AdminProducts/AdminProductForm">
            <button className="flex items-center justify-center bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700 max-sm:w-full">
                <FontAwesomeIcon icon={faPlus} className="mr-2" />
                Add product
            </button>
          </Link>
          
          
          {/* View Product Button */}
          <Link to="/AdminProducts/AdminViewProductPage">
            <button className="flex items-center justify-center border max-sm:w-full border-blue-600 text-blue-600 px-4 py-2 rounded shadow hover:bg-blue-600 hover:text-white">
                <FontAwesomeIcon icon={faEye} className="mr-2" />
                View product
            </button>
          </Link>
          
        </div>
      </div>

      {/* Right Section - Shopping Cart Image */}
      <div>
        <img src={ShoppingCartImage} alt="Shopping Cart" className="w-[120px] h-[120px] object-contain" />
      </div>
    </div>
  );
};

export default AdminProductActions;
